<template>
  <div class="seleccion">
    <caja-header eyebrow="Punto de venta · Paso 1 de 3" titulo="¿Dónde estás hoy?">
      <span class="avatar">{{ inicial(user && user.username) }}</span>
      <span>Hola <b>{{ user && user.username }}</b>, elegí la sucursal en la que vas a trabajar.</span>
    </caja-header>

    <div class="grilla" v-if="loading">
      <div v-for="i in 3" :key="i" class="tarjeta esqueleto"></div>
    </div>

    <div class="grilla" v-else-if="sucursales.length">
      <button
        v-for="sucursal in sucursales"
        :key="sucursal.uuid"
        type="button"
        class="tarjeta"
        :class="{ eligiendo: eligiendo === sucursal.uuid }"
        :disabled="eligiendo !== null"
        @click="setSucursal(sucursal)"
      >
        <v-icon size="30" color="#BA6B30" class="mb-2">mdi-storefront-outline</v-icon>
        <div class="nombre">{{ sucursal.nombre }}</div>
        <div class="direccion">
          {{ sucursal.direccion }}
          <span v-if="sucursal.localidad && sucursal.localidad.nombre">· {{ sucursal.localidad.nombre }}</span>
        </div>
        <div class="cta">
          Entrar
          <v-icon small color="#e3b08a">mdi-arrow-right</v-icon>
        </div>
      </button>
    </div>

    <v-alert v-else dense text type="info" border="left">
      No tenés sucursales asignadas. Pedile a un administrador que te asigne una.
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CajaHeader from "@/components/caja/CajaHeader.vue";

export default {
  name: "Sucursales",
  components: { CajaHeader },
  data() {
    return {
      loading: false,
      sucursales: [],
      eligiendo: null,
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    ...mapActions("sucursales", ["validate_asignacion_sucursal", "validate_caja", "fetchArqueoVigente"]),

    inicial(nombre) {
      return (nombre || "?").charAt(0).toUpperCase();
    },
    // Si en esta sucursal ya tengo una caja con arqueo abierto voy directo al
    // POS; si no, a elegir caja.
    async setSucursal(sucursal) {
      this.eligiendo = sucursal.uuid;
      this.$store.commit("setLoadingInit", true);
      try {
        const asignacion = await this.validate_asignacion_sucursal(sucursal.uuid);
        if (!asignacion.success) {
          this.eligiendo = null;
          return;
        }
        const caja = await this.validate_caja();
        if (caja.success && caja.response.data.caja) {
          const arqueo = await this.fetchArqueoVigente();
          if (arqueo.success && arqueo.response.data.arqueo_de_caja) {
            this.$router.push({ name: "pos.dashboard" });
            return;
          }
        }
        this.$router.push({ name: "pos.cajas" });
      } catch (error) {
        this.eligiendo = null;
      } finally {
        this.$store.commit("setLoadingInit", false);
      }
    },
    async fetchSucursales() {
      this.loading = true;
      try {
        const response = await this.axios.get("/sucursales/sucursales");
        this.sucursales = response.data;
      } catch (error) {
        this.sucursales = [];
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchSucursales();
  },
};
</script>

<style scoped>
.seleccion {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 20px 40px;
}
.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(186, 107, 48, 0.18);
  color: #e3b08a;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.grilla {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
  margin-top: 6px;
}
.tarjeta {
  text-align: left;
  background: #1e1e1e;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 18px;
  padding: 18px 18px 16px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.12s, border-color 0.12s, background 0.12s;
  color: inherit;
  font: inherit;
}
.tarjeta:hover:not(:disabled) {
  transform: translateY(-2px);
  border-color: rgba(186, 107, 48, 0.6);
  background: #232323;
}
.tarjeta:focus-visible {
  outline: 2px solid #BA6B30;
}
.tarjeta.eligiendo {
  opacity: 0.7;
}
.tarjeta.esqueleto {
  cursor: default;
  background: linear-gradient(90deg, #1e1e1e 25%, #262626 50%, #1e1e1e 75%);
  background-size: 200% 100%;
  animation: brillo 1.2s infinite;
}
@keyframes brillo {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.nombre {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}
.direccion {
  font-size: 13px;
  color: #8a8a8a;
}
.cta {
  margin-top: auto;
  padding-top: 14px;
  font-size: 14px;
  font-weight: 600;
  color: #e3b08a;
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
